module.exports = __webpack_public_path__ + "img/physician1.6fde2bed.svg";